<template>
    <div>
        <div class="container" style="min-width: 900px">
            <el-form :inline="true" ref="userForm" :model="task" class="demo-form-inline">
                <div>
                    <el-form-item label="任务内容" prop="task">
                        <el-input v-model="task.taskMsg" style="width: 260px;"></el-input>
                    </el-form-item>
                </div>
                <div class="block">
                    <el-form-item label="结束日期" prop="task">
                        <el-date-picker v-model="task.endTime" type="datetime" placeholder="选择日期时间"
                            value-format="yyyy-MM-dd HH:mm:ss" />
                    </el-form-item>
                </div>

                <el-form-item>
                    <el-button type="primary" @click="submit()">更新任务</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
import { setTaskTiming } from '../../api/timing.js'

export default {
    name: 'TaskTimingModify',
    data: function () {
        return {
            task: {
                id: "",
                taskMsg: "",
                endTime: ""
            },
        }
    },
    created() {
        this.task.id = this.$route.query.taskid;
    },
    methods: {
        submit() {
            var id;
            if (this.$route.query.taskid != null) {
                id = this.$route.query.taskid;
            }

            let params = {
                "id": id, "taskMsg": this.task.taskMsg,
                "endTime": this.task.endTime
            }
            setTaskTiming(params).then(res => {
                if (res.status == 200) {
                    alert("更新成功")
                }
            })
        }
    }
}

</script>